module.exports = __webpack_public_path__ + "81dd8923c8b1276770b80910eec2e7be.jpg";